import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
var _weight, _weight1;
var makeLinkTypeMapper = function(staticLinks) {
    return function(type) {
        return staticLinks.filter(function(link) {
            return link.type === type;
        }).sort(function(a, b) {
            return ((_weight = b.weight) !== null && _weight !== void 0 ? _weight : 0) - ((_weight1 = a.weight) !== null && _weight1 !== void 0 ? _weight1 : 0);
        }).map(function(_param) {
            var title = _param.title, link = _object_without_properties(_param, [
                "title"
            ]);
            if (!title) {
                return link;
            }
            return _object_spread_props(_object_spread({}, link), {
                title: title
            });
        });
    };
};
export { makeLinkTypeMapper };
